<template>
 <div class="home">
   <navbar :is-active="2"></navbar>
   <div class="body">
     <div class="body__sidebar" id="body__sidebar">
       <div class="nav-mob-resp">
       <hidden-arrow></hidden-arrow>
       <div class="title">
         <div class="title__icon">
           <i class="fas fa-home"></i>
         </div>
         <div class="title__text">
           <h2>{{company_name}}</h2>
           <p>Selecciona una opción</p>
         </div>
       </div>
       <div class="tabs">
         <router-link to="/Client/cp-productos" class="tab">
           <div class="tab__icon">
             <i class="fab fa-product-hunt"></i>
           </div>
           <div class="tab__text">
             <p>Productos</p>
           </div>
         </router-link>
         <router-link to="/Client/cp-clientes" class="tab">
           <div class="tab__icon">
             <i class="fas fa-user-friends"></i>
           </div>
           <div class="tab__text">
             <p>Clientes</p>
           </div>
         </router-link>
         <router-link to="/Client/cp-boletas" class="tab active">
           <div class="tab__icon">
             <i class="fas fa-file-invoice-dollar"></i>
           </div>
           <div class="tab__text">
             <p>Boletas</p>
           </div>
         </router-link>
       </div>
       </div>
     </div>
     <div class="body__containt">
       <div class="page__title">
         <open-arrow></open-arrow>
         <h2>Boletas</h2>
       </div>

       <div class="page__filters">
         <input
           v-model="invoice_id"
           @keyup="search"
           type="text"
           placeholder="Código boleta quickshop"
         />
         <input
           @keyup="search"
           v-model="invoice_user_id"
           type="text"
           placeholder="Código cliente"
         />
         <input
             @keyup="search"
             v-model="invoice_branch_office_id"
             type="text"
             placeholder="Código sucursal"
         />
         <input
         @keyup="search"
           v-model="branch_name"
           type="text"
           placeholder="Nombre sucursal"
         />

         <p class="clean_filter" @click="openModal()">Ver más filtros</p>
         <p @click="clean_filter()" class="clean_filter">Limpiar Filtros</p>

         <!-- ################################################################################################################### -->
        <vue-final-modal  v-model="showModal"  classes="modal-container" content-class="modal-content">
          <h2>Filtros de búsqueda</h2>
          <div class="page__buttons" >
            <button style="background: #ff3128; height: 1rem; margin-top: -5rem; width: 1.1rem;padding: 10px 4px;border-radius: 15px;font-size: 17px;color: #fff;border: none;display: flex;align-items: center;justify-content: space-between;" @click="this.showModal = false">
              <span style="margin-top: -3px;">x</span>
            </button>
          </div>

          <div class="">
            <section class="page__filters" style="align-items: center; display: flex; flex-direction: row; justify-content: space-between;">
              <div class="input" style="align-items: center; display: flex; flex-direction: row; justify-content: space-between;">
          <div style="display: flex; flex-direction:column; margin-top: 1rem;">
          <label style="">Fecha de compra</label>
          <input
            v-model="modal_invoice_date_purchase_desde"
            style="width: 11rem; margin-right: 1.5rem;"
            type="datetime-local"  
          />
          </div>
            <input
              style="margin-top:3rem; width: 11rem; margin-right: 1.5rem;"
              v-model="modal_invoice_date_purchase_hasta"
              type="datetime-local"  
            />
          <div style="display: flex; flex-direction:column; margin-top: 1rem;">
            <label style="">Fecha de proceso</label>
            <input
              v-model="modal_invoice_date_proces_desde"
              type="datetime-local"  
              style="width: 11rem; margin-right: 1.5rem;"
            />
          </div>
          <input
            v-model="modal_invoice_date_proces_hasta"
            style="margin-top:3rem; width: 11rem; margin-right: 1.5rem;"
            type="datetime-local"  
            placeholder="Fecha hasta"
          />
          <div style="display: flex; flex-direction:column; margin-top: 1rem;">
          <label>Fecha de validación</label>
          <input
            v-model="modal_invoice_date_validation_desde"
            style="width: 11rem; margin-right: 1.5rem;"
            type="datetime-local"  
          />
          </div>
          <input
            v-model="modal_invoice_date_validation_hasta"
            style="width: 11rem; margin-right: 1.5rem; margin-top: 3rem;"
            type="datetime-local"  
          />
          </div>
            <div class="page__filters" style="display: flex; justify-content: center; margin-top: 1rem;">
              <input
                v-model="modal_code_product"
                type="text"
                placeholder="Código de producto"
              />
            </div>
            </section>
            <button @click="search"  style="background: #e1e1e1; width: 100%;padding: 15px 20px;border-radius: 15px;font-size: 17px;color: #fff;border: none;display: flex;align-items: center;justify-content: center; margin-top:2rem;">
              <span style="color:red; font-weight:bold;">Buscar</span>
            </button>
            <div class="table-headers">
              <p v-for="{ label } of columnsModal" :key="label">{{ label }}</p>
            </div>
            <div class="table-body">
              <!-- <div class="data" v-for="product of dataModal.products.data" :key="product.id" style="justify-content: center;">
                  <p>{{ product.product_code }}</p>
                  <p>{{ product.product_name }}</p>
                  <p>{{ product.product_descripcion }}</p>
                  <p>{{ product.type }}</p>
              </div> -->

              <!-- <div style="text-align: center;" v-if="productEmpty">
                <h4 style="color: #938f8f; padding: 50px;">No se encontraron datos</h4>
              </div> -->
            </div>

            <!-- <div class="page__pagination" style="padding-top: 2%;">
              <Pagination
                  :data="paginationProduct"
                  v-on:changePage="handleClickInProduct"
              />
            </div> -->

          </div>
        </vue-final-modal>
       <!-- ################################################################################################################## -->

       </div>
       <div class="page__buttons">
         <ButtonExport
           :data="invoice_export"
           :columns="columns"
           icon="fas fa-download"
           :sheet-name="'Datos Boletas'"
           :file-name="'Reporte Boletas'"
         />
       </div>
       <div class="page__table" style="height: 100%; overflow: auto">
         <div class="table-headers">
           <p v-for="{ label } of columns" :key="label">{{ label }}</p>
           <p>Accion</p>
         </div>
         <div class="table-body">
           <div
             class="data"
             v-for="invoice of invoices"
             v-bind:key="invoice.id"
           >
             <p>
               {{ codeFormat(invoice.id) }}
             </p>
             <p>{{ invoice.invoice_amount }}</p>
             <p>{{ invoice.invoice_price }}</p>
             <p>
               {{ codeFormat(invoice.branch_code) }}
             </p>
             <p>
               {{ invoice.codigo_cliente }}
             </p>
             <p>{{ invoice.nombre }}</p>
             <p>{{ invoice.apellido }}</p>
             <p>{{ invoice.invoice_date_purchase }}</p>
             <p>{{ invoice.invoice_date_validation ? invoice.invoice_date_validation : '-'  }}</p>
             <p>{{ (invoice.estado) }}</p>

             <div class="dropdown" >
               <button class="button" @click="show('id-dropdown-content'+invoice.id)">
                 <i class="fa fa-ellipsis" style="color: red"></i>
               </button>
               <div @mouseleave="show('id-dropdown-content'+invoice.id)"  class="dropdown-content" :id="'id-dropdown-content'+invoice.id">
                 <router-link :to="{ path: '/ProductDetalleCliente', query: { id: invoice.id }}" class="dropdown-item">
                   <i class="fa fa-eye"></i> Ver detalle
                 </router-link>
                 <router-link :to="{ path: '/ClienteConciliaDetalleCLiente', query: { id: invoice.invoice_user_id }}" class="dropdown-item">
                   <i class="fa fa-user"></i> Buscar cliente
                 </router-link>
                 <a  :href=descargarBoleta+invoice.id>
                   <div class="dropdown-item" >
                     <i class="fa fa-download" ></i> Descargar Boleta
                   </div>
                 </a>
               </div>
             </div>

           </div>
            <div style="text-align: center;" v-if="empty">
             <h4 style="color: #938f8f; padding: 50px;">No se encontraron datos</h4>
           </div>
         </div>
       </div>
       <div class="page__pagination">
         <Pagination
             :data="pagination"
             v-on:changePage="handleClickInParent"
         />
       </div>
     </div>
   </div>
 </div>
</template>

<script>
 import axios from 'axios'
 import Navbar from '@/components/NavBar'
 import { codeFormat, dateFormat } from '@/utils/formats'
 import Dropdown from '@/components/Dropdown.vue'
 import ButtonExport from '@/components/ButtonExport.vue'
 import Pagination from '@/components/Pagination.vue'
 import OpenArrow from '@/components/OpenArrow.vue'
 import HiddenArrow from '@/components/HiddenArrow.vue'
 import { VueFinalModal } from 'vue-final-modal'
 import $ from 'jquery'

 export default {
   name: 'Boletas',
   components: {
     Navbar,
     ButtonExport,
     Dropdown,
     Pagination,
     OpenArrow,
     HiddenArrow,
     VueFinalModal
   },
   data() {
     return {
       showDropdwon: true,
       showModal: false,
       pagination : [],
       brand: '',
       empty: false,
       timeout: null,
       invoice_id: '',
       invoice_user_id: '',
       invoice_branch_office_id: '',
       branch_name: '',
       invoice_export: [],
       modal_code_product: '',
       modal_invoice_date_validation_desde: '',
       modal_invoice_date_validation_hasta: '',
       modal_invoice_date_proces_hasta: '',
       modal_invoice_date_proces_desde: '',
       modal_invoice_date_purchase_hasta: '',
       modal_invoice_date_purchase_desde: '',
       descargarBoleta: axios.defaults.baseURL + 'general/download/invoice/',
       type: 'ClienteBoletaAcction',
       columns: [
         {
           label: 'Código boleta quickshop',
           field: 'id',
           dataFormat: this.codeFormat
         },
         { label: 'Cantidad de productos', field: 'invoice_amount' },
         { label: 'Precio de venta', field: 'invoice_price' },
         {
           label: 'Código sucursal',
           field: 'branch_code',
           dataFormat: this.codeFormat
         },
         {
           label: 'Código cliente',
           field: 'codigo_cliente',
           dataFormat: this.codeFormat
         },
         { label: 'Nombres', field: 'nombre' },
         { label: 'Apellidos', field: 'apellido' },
         { label: 'Fecha de compra', field: 'invoice_date_purchase', dataFormat: this.dateFormat },
         { label: 'Fecha de validación', field: 'invoice_date_validation', dataFormat: this.dateFormat },
         { label: 'Estado de boleta', field: 'invoice_status', conditionalFormatBoleta: this.conditionalFormatBoleta }
       ]
     }
   },
   methods: {
       async buscarModal(page = 1, paramSearch = {}) {
         await axios.get('general/invoice', {params: {
           page: page,
         }
       }).then( res => {
         if(res.data.data.total > 0){
           this.invoices = res.data.data.data
           this.pagination = res.data.data
           this.invoice_export = res.data.export
           this.empty = false
         }else{
           this.invoices = {}
           this.pagination = {}
           this.empty = true
         }
     })
     },
     openModal(){
       this.showModal = true
     },
     handleClickInParent: function(page) {
       this.getall(page)
     },
     clean_filter(){
       this.invoice_id = ''
       this.invoice_user_id = ''  
       this.invoice_branch_office_id = ''
       this.branch_name = ''
       this.modal_code_product = ''
       this.modal_invoice_date_validation_desde = null
       this.modal_invoice_date_validation_hasta = null
       this.modal_invoice_date_proces_hasta = null
       this.modal_invoice_date_proces_desde = null
       this.modal_invoice_date_purchase_hasta = null
       this.modal_invoice_date_purchase_desde = null
       this.getall()
     },
     search: function() {
       clearTimeout(this.timeout);
       var self = this;
       this.timeout = setTimeout(function () {
         console.log(self)
         let paramSearch = {
           invoice_company_id: self.invoice_company_id,
           invoice_id: self.invoice_id,
           invoice_user_id: self.invoice_user_id,
           invoice_branch_office_id: self.invoice_branch_office_id,
           imagen: self.product_image,
           branch_name: self.branch_name,
           modal_code_product: self.modal_code_product,
           modal_invoice_date_validation_desde: self.modal_invoice_date_validation_desde,
           modal_invoice_date_validation_hasta: self.modal_invoice_date_validation_hasta,
           modal_invoice_date_proces_hasta: self.modal_invoice_date_proces_hasta,
           modal_invoice_date_proces_desde: self.modal_invoice_date_proces_desde,
           modal_invoice_date_purchase_hasta: self.modal_invoice_date_purchase_hasta,
           modal_invoice_date_purchase_desde: self.modal_invoice_date_purchase_desde,
         }
         this.getall(1, paramSearch)
         this.showModal = false
       }.bind(this), 500);
     },
     async getBrand(){
       const params = {
         invoice_company_id:  localStorage.getItem('company_id')
       }
       await axios.get('general/elements/brand', params).then(res => {
         this.brand = res.data.data
       })
     },
     codeFormat,
     dateFormat,
     async getall(page = 1, paramSearch = {}) {
       await axios.get('general/invoice', {params: {
        page: page,
        invoice_company_id:localStorage.getItem('company_id'),
        id: (typeof paramSearch.invoice_id === 'undefined' || paramSearch.invoice_id === '') ? null : parseInt(paramSearch.invoice_id),
        codigo_cliente: (paramSearch.invoice_user_id) ? paramSearch.invoice_user_id : null,
        branch_code:(typeof paramSearch.invoice_branch_office_id === 'undefined' || paramSearch.invoice_branch_office_id === '') ? null : parseInt(paramSearch.invoice_branch_office_id),
        branch_name: paramSearch.branch_name,
        purchase_start: (paramSearch.modal_invoice_date_purchase_desde) ? paramSearch.modal_invoice_date_purchase_desde : null,
        purchase_end: (paramSearch.modal_invoice_date_purchase_hasta) ? paramSearch.modal_invoice_date_purchase_hasta : null,
        proces_start: (paramSearch.modal_invoice_date_proces_desde) ? paramSearch.modal_invoice_date_proces_desde : null,
        proces_end: (paramSearch.modal_invoice_date_proces_hasta) ? paramSearch.modal_invoice_date_proces_hasta : null,
        validate_start: (paramSearch.modal_invoice_date_validation_desde) ? paramSearch.modal_invoice_date_validation_desde : null,
        validate_end: (paramSearch.modal_invoice_date_validation_hasta) ? paramSearch.modal_invoice_date_validation_hasta : null,
        product_code: (paramSearch.modal_code_product) ? paramSearch.modal_code_product : '',
     }}).then( res => {
       if(res.data.data.total > 0){
         this.invoices = res.data.data.data
         this.pagination = res.data.data
         this.invoice_export = res.data.export
         this.empty = false
       }else{
         this.invoices = {}
         this.pagination = {}
         this.empty = true
       }
     })
     },
      show(divID){
        if (!$("body").hasClass("cerrarModal")){
          $('#'+divID).fadeIn();
          setTimeout(function () {
            $("body").addClass("cerrarModal");
          }, 10);
        }
      },
   },
   mounted() {
     if (localStorage.getItem('token')) {
       this.getall()
       this.getBrand()
       this.company_name = localStorage.getItem('company_name');
     } else {
       this.$router.push('/login')
     }
   }
 }
</script>

<style scoped>
#columnas{
 column-count:3;
 column-gap:40px;
 column-rule:4px dotted gray;
}
::v-deep .modal-container {
 display: flex;
 justify-content: center;
 align-items: center;
}
::v-deep .modal-content {
 position: relative;
 display: flex;
 flex-direction: column;
 max-height: 90%;
 margin: 0 7rem;
 padding: 1rem;
 border: 1px solid #e2e8f0;
 border-radius: 0.25rem;
 background: #fff;
 width: 64%;
}
 .home .navbar__center ul {
   width: 100%;
   height: 100%;
   display: flex;
   list-style: none;
   display: flex;
   justify-content: flex-start;
 }
 .home .navbar__center ul li {
   text-decoration: none;
   height: 100%;
   display: flex;
   justify-content: center;
   align-items: center;
   margin: 0 10px;
   position: relative;
   cursor: pointer;
 }

 .home .navbar__center ul li.active {
   color: #ff3128;
 }
 .home .navbar__center ul li.active::before {
   width: 100%;
 }

 .home .navbar__center ul li::before {
   content: '';
   position: absolute;
   bottom: 0;
   width: 0;
   height: 4px;
   background-color: #ff3128;
   transition: 0.3s ease;
 }
 .home .navbar__center ul li:hover {
   color: #ff3128;
 }
 .home .navbar__center ul li:hover::before {
   width: 100%;
 }
 .home .navbar__right .profile__detail p {
   margin: 0;
 }
 .home .navbar__right .profile__detail span {
   color: #938f8f;
   font-weight: 300;
 }

 .home {
   width: 100vw;
   height: 100vh;
   display: flex;
   flex-direction: column;
   font-family: 'Readex Pro', sans-serif;
 }

 .body {
   width: 100%;
   height: 600px;
   display: flex;
 }
 .body__containt {
   height: calc(100vh - 120px);
   box-shadow: 1px 10px 10px rgba(0, 0, 0, 0.1);
 }
 .body__sidebar {
   width: 400px;
   position: relative;
   display: flex;
   flex-direction: column;
 }

 .body__sidebar .floating-icon {
   position: absolute;
   right: -15px;
   top: 30px;
   color: #ff3128;
   font-size: 30px;
 }

 .body__sidebar .title {
   width: 100%;
   height: 140px;
   border-bottom: 1px solid #b6b6b6;
   display: flex;
   align-items: center;
   justify-content: center;
 }
 .body__sidebar .title__icon {
   color: #ff3128;
   font-size: 20px;
 }
 .body__sidebar .title__text {
   margin: 0 10px;
 }

 .body__sidebar .title__text h2 {
   font-size: 20px;
   margin: 0;
 }
 .body__sidebar .title__text p {
   margin: 0;
   font-weight: 300;
 }

 .body__sidebar .tabs {
   width: 100%;
   display: flex;
   flex-direction: column;
   align-items: center;
   height: calc(100% - 140px);
   padding-top: 5px;
 }

 .body__sidebar .tabs .tab {
   width: 90%;
   height: 70px;
   border-radius: 10px;
   color: #707070;
   display: flex;
   align-items: center;
   padding: 0 20px;
   margin-bottom: 10px;
   cursor: pointer;
   transition: 0.3 ease;
 }
 .body__sidebar .tabs .tab:hover,
 .body__sidebar .tabs .tab.active {
   color: #ff3128;
   background: #ffeeed;
 }

 .body__sidebar .tabs .tab__icon {
   font-size: 20px;
   margin-right: 10px;
 }

 .body__sidebar .tabs .tab__text p {
   margin: 0;
   font-weight: 600;
 }

 .body__containt {
  height: fit-content;
  min-height: 87vh;
   width: 100%;
   display: flex;
   flex-direction: column;
   padding: 20px 30px;
 }

 .body__containt .page__title {
   width: 100%;
   margin-bottom: 20px;
 }

 .body__containt .page__title h2 {
   font-weight: 600;
   color: #ff3128;
   font-size: 25px;
 }
 .vfm__content .modal-content{
   width: 64%;
 }
 .body__containt .page__filters {
   display: flex;
   justify-content: flex-start;
   flex-wrap: wrap;
   gap: 20px;
 }
 .body__containt .page__filters input,
 select {
   border-radius: 10px;
   border: 1px solid #e4e4e4;
   background: #fff;
   padding: 15px 20px;
   /*margin: 0 10px;*/
   width: 300px;
 }

 .body__containt .page__buttons {
   width: 100%;
   display: flex;
   justify-content: flex-end;
   gap: 20px;
   padding-top: 2%;
 }

 .body__containt .page__buttons .button {
   width: 250px;
   padding: 15px 20px;
   border-radius: 15px;
   font-size: 17px;
   color: #fff;
   border: none;
   display: flex;
   align-items: center;
   justify-content: space-between;
 }
 .body__containt .page__buttons .button:nth-child(1) {
   background: #262626;
 }

 .body__containt .page__table {
   width: 100%;
   min-height: 200px;
   display: flex;
   flex-direction: column;
   margin-top: 50px;
 }

 .body__containt .page__table .table-headers {
   width: 180%;
   height: 50px;
   display: flex;
   justify-content: space-between;
   border-bottom: 1px solid #b6b6b6;
 }
 .body__containt .page__table .table-headers p {
   width: calc(100% / 7);
   display: flex;
   justify-content: center;
   align-items: center;
   font-weight: 600;
 }

 .body__containt .page__table .table-body {
   width: 180%;
   display: flex;
   flex-direction: column;
   border-bottom: 1px solid #b6b6b6;
 }

 .body__containt .page__table .table-body .data {
   width: 100%;
   display: flex;
   justify-content: space-between;
 }
 .body__containt .page__table .table-body .data p {
   width: calc(100% / 7);
   display: flex;
   justify-content: center;
   align-items: center;
   font-weight: 300;
   margin: 10px 0;
 }
 .body__containt .page__table .table-body .data p:nth-child(1) {
   color: #ff3128;
 }
 .body__sidebar.open{
   display: none;
 }
/* INICIO MOBILE*/
@media (max-width: 768px){
  .body__containt .page__title h2{
    font-size: 21px;
  }
  .body__containt .page__filters input{
    padding: 5px 20px;
  }
  .page__filters select{
    padding: 10px 19px;
    width: 54% !important;
  }
  .body label{
    margin-top: 2rem;
    margin-left: 18px;
    font-size: 13px;
  }
  .body p.clean_filter{
    margin-top: 7px;
    font-size: 14px;
  }
  .buttonExport{
    margin-top: -13px;
    width: 179px;
    padding: 9px 20px;
  }
  .body__containt .page__table{
    font-size: 11px;
  }
  .body__containt .page__table .table-headers{
    margin-top: 6px;
    width: 245%;
  }
  .body__containt .page__table .table-body{
    width: 245%;
  }
  .body__containt .page__table .table-body{
    width: 245%;
  }
  .body__sidebar .title__text h2 {
    font-size: 18px;
  }
  .body__sidebar .title__text {
    margin: 0 10px;
    font-size: 16px;
  }
  .body__sidebar .title__icon{
    font-size: 16px;
    margin-left: 6px;
  }
  .body__sidebar .tabs .tab__icon svg{
    font-size: 15px;
    margin-right: 7px;}
  .body__sidebar .tabs .a{
    margin-left: -2px;
    margin-top: -1px;
  }
  .body__sidebar a svg{
    font-size: 22px;
  }
  /*BARRA LATERAL IZQUIERDA MOBILE*/
  .body__sidebar .tabs .tab__icon {
    color: white;
  }
  .body__sidebar .tabs .tab:hover, .body__sidebar .tabs .tab.active svg {
    color: #ff3128;
  }
  .body__sidebar .tabs .tab:hover, .body__sidebar .tabs .tab.active p {
    color: #ff3128;
    font-size: 20px;
  }
  .body__sidebar .tabs .tab__text p {
    margin-left: -8px;
    color: white;
    font-size: 18px;
  }
  .body__sidebar .tabs .tab:hover, .body__sidebar .tabs .tab.active{
    background: #262626;
    margin-bottom: -11px;
  }
  .body__containt .page__buttons .button{
    font-size: 13px;
    padding: 5px 20px;
    margin-top: -18px;
  }
  .body__containt .page__buttons {
    width: 105%;
  }
  .home .body .nav-mob-resp{
    position: absolute;
    background: #262626;
    height: 85vh;
    width: 25vh;
  }
  .body__sidebar .title {
    color: white;
  }
  .body__sidebar .floating-icon {
    position: absolute;
    right: -35px;
  }
  .body__sidebar .tabs .tab{
    margin-bottom: -7px;
  }
}
</style>

